import { analytics } from '@/firebase';
import { logEvent } from 'firebase/analytics';

// Guarded GA4 (Firebase Analytics) event helper. `analytics` is null where GA4
// isn't supported (SSR/prerender/tests, or blocked), so every call is guarded and
// wrapped — analytics must never break a user flow.
export function track(event, params = {}) {
  try {
    if (analytics) logEvent(analytics, event, params);
  } catch (e) {
    // no-op: telemetry is best-effort.
  }
}

export const USD = 'USD';
export const POSTCARD_ITEM = { item_id: 'postcard', item_name: 'AI Postcard' };
export const MEMBERSHIP_ITEM = { item_id: 'membership', item_name: 'Thinking of U Membership' };
